export const SET_SUBSPECIALTY = 'SET_SUBSPECIALTY';
export const SET_SUBSPECIALTIES = 'SET_SUBSPECIALTIES';
export const SET_SUBSPECIALTIES_QUERY_PARAMS = 'SET_SUBSPECIALTIES_QUERY_PARAMS';
export const SET_SUBSPECIALTIES_SET_IS_FETCHING = 'SET_SUBSPECIALTIES_SET_IS_FETCHING';

export const SET_DICTSUBSPECIALTY = 'SET_DICTSUBSPECIALTY';
export const SET_DICTSUBSPECIALTIES = 'SET_DICTSUBSPECIALTIES';
export const SET_DICTSUBSPECIALTY_SET_IS_FETCHING = 'SET_DICTSUBSPECIALTY_SET_IS_FETCHING';
export const SET_DICTSUBSPECIALTIES_QUERY_PARAMS = 'SET_DICTSUBSPECIALTIES_QUERY_PARAMS';
